import { ACTIONS } from "../../Models/ENUM";
import { GameInfo } from "../../Pages/GameInfo";
import CONQUER from "../CONQUER";
import GameInstance from "./GameInstance";
import LOG, { log } from "../../UTIL/LOG";
import CONFIG, {toyListUrl} from "../../Core/CONFIG/CONFIG";
import { VariableInstance } from "twilio/lib/rest/serverless/v1/service/environment/variable";

class Games
{
    private conquer : CONQUER;
    public Game     : any | GameInstance;

    public constructor( instance:CONQUER ) 
    {
        this.conquer = instance;
    }

    public async get() : Promise<any>
    {
        // Move the builder stuff here 
        
        let games = await this.conquer.do( ACTIONS.GAME_GET, { isPublic: true });
        return Promise.resolve( games );

    }
 
    /*=============== 


    GET
    

    ================*/

    public async getOne( gameKey:any ) : Promise<any>
    {
        this.Game       = new GameInstance( this.conquer, gameKey );
        
        return this.refresh();
    };

    public async getData( gameKey:any ) : Promise<any>
    {
        let game = await this.conquer.do( ACTIONS.GAME_GETDATA, {gameKey} );
        return Promise.resolve( game );
    };

    public async refresh() : Promise<any>
    {
        if( !this.Game ) return Promise.resolve(); 
 
        await this.Game.init();

        return Promise.resolve( this.Game ); 
    }
 
    public async set( params:any ): Promise<any> 
    {
        return await this.conquer.do( ACTIONS.GAME_SET, params );
    }


}

export default Games;